// @flow

import { createSelector } from 'reselect';
import { getEventEntities } from 'modules/event/selector';

const getRecentEventIds = (state: Map<*, *>) => state.getIn([ 'homePage', 'recentEventsList' ]);
export const getRecentEvents = createSelector(
  [ getEventEntities, getRecentEventIds ],
  (events, ids) => {
    const list = events.toSet().sortBy(e => e.get('startDate')).reverse().filter((t) => {
      return ids.indexOf(t.get('applicationName')) > -1;
    });
    return list.take(10);
  },
);
